// ----------------------------------------------------------------------
// <copyright file="Izenda.Metrics.jsx" company="Izenda">
//  Copyright (c) 2015 Izenda, Inc.
//  ALL RIGHTS RESERVED
//
//  The entire contents of this file is protected by U.S. and
//  International Copyright Laws. Unauthorized reproduction,
//  reverse-engineering, and distribution of all or any portion of
//  the code contained in this file is strictly prohibited and may
//  result in severe civil and criminal penalties and will be
//  prosecuted to the maximum extent possible under the law.
//
//  RESTRICTIONS
//
//  THIS SOURCE CODE AND ALL RESULTING INTERMEDIATE FILES
//  ARE CONFIDENTIAL AND PROPRIETARY TRADE
//  SECRETS OF IZENDA INC. THE REGISTERED DEVELOPER IS
//  LICENSED TO DISTRIBUTE THE PRODUCT AND ALL ACCOMPANYING .NET
//  CONTROLS AS PART OF AN EXECUTABLE PROGRAM ONLY.
//
//  THE SOURCE CODE CONTAINED WITHIN THIS FILE AND ALL RELATED
//  FILES OR ANY PORTION OF ITS CONTENTS SHALL AT NO TIME BE
//  COPIED, TRANSFERRED, SOLD, DISTRIBUTED, OR OTHERWISE MADE
//  AVAILABLE TO OTHER INDIVIDUALS WITHOUT EXPRESS WRITTEN CONSENT
//  AND PERMISSION FROM IZENDA INC.
//
//  CONSULT THE END USER LICENSE AGREEMENT(EULA FOR INFORMATION ON
//  ADDITIONAL RESTRICTIONS.
// </copyright>
// ----------------------------------------------------------------------

import React, { Component, PropTypes } from 'react';
import { omit, keys, map } from 'lodash/fp';
import classnames from 'classnames';
import Panel from './Izenda.Panel';
import Button from './Izenda.Button';
import connect from 'share/enhancers/Izenda.Connect';
import localizer from 'share/localization/Izenda.Localizer';

@connect()
export default class Metrics extends Component {
  static propTypes = {
    dataSource: PropTypes.array.isRequired,
    itemComponent: PropTypes.func.isRequired,
    onAddMetric: PropTypes.func,
    onDeleteMetric: PropTypes.func,
    maximumMetrics: PropTypes.number,
    canAdd: PropTypes.bool,
    canDelete: PropTypes.bool,
    isExpanded: PropTypes.bool
  };

  static defaultProps = {
    dataSource: [],
    isExpanded: true,
    canAdd: true,
    canDelete: true
  };

  renderMetric(item, index) {
    const { props, props: { canDelete } } = this;

    const handleDelete = () => {
      const { props: { onDeleteMetric } } = this;
      onDeleteMetric && onDeleteMetric(index);
    };

    const headerComponent = headerProps => {
      const classes = classnames('pull-right', { 'disabled-elm': !canDelete });
      const hint = headerProps.isExpanded
        ? localizer.getText('COMMON_LABEL_COLLAPSE')
        : localizer.getText('COMMON_LABEL_EXPAND');
      return (
        <div className='left-header-metric'>
          <div className='inline-block' onClick={headerProps.collapseToggle}>
            <i title={hint} className='icon-toggle'/>
            <span className='panel-title'>{[localizer.getText('COMMON_LABEL_METRIC'), index + 1].join(' ')}</span>
          </div>
          <a title={localizer.getText('COMMON_LABEL_DELETE')} className={classes} onClick={handleDelete}>
            <span className='icon-cancel'/>
          </a>
        </div>
      );
    };

    const header = {
      component: headerComponent
    };

    const itemProps = omit(keys(Metrics.propTypes), props);
    return (
      <Panel key={index} header={header} collapsible={true} initState={props.isExpanded}>
        <props.itemComponent {...itemProps} value={item} index={index}/>
      </Panel>
    );
  };

  render() {
    const { props } = this;
    const { dataSource } = props;
    const classes = classnames('metrics', props.className);

    const handleAddMetric = () => {
      if (!props.canAdd) return;
      if (props.maximumMetrics) {
        dataSource.length < props.maximumMetrics && props.onAddMetric && props.onAddMetric();
        return;
      }
      props.onAddMetric && props.onAddMetric();
    };

    const isAddButtonDisabled = !props.canAdd || dataSource.length >= props.maximumMetrics;
    return (
      <div className={classes}>
        {dataSource.map(this.renderMetric.bind(this))}
        <div className='metrics-footer'>
          <Button
            disabled={isAddButtonDisabled}
            className='pull-right'
            label={localizer.getText('COMPONENT_CONTROL_LABEL_ADD_METRIC')}
            onClick={handleAddMetric}
          />
        </div>
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./ui/share/components/controls/Izenda.Metrics.js